<template>
  <div class="anthemBG">
    <div class="panel" style="transform:scale(1)">
      <div class="panelTop">
        <div class="title">Leaderboard</div>
        <div class="subTitle" >Every amazing player who has swung the bat with us.</div>
        <div class="searchRow">
          
         
        <div>FIND YOUR SCORE
          <SearchBox class="searchBox" @showScore="showScore" @results="showResults" :placeHolder="'Your Name'"  :items="names"  :validation="['inList']" />
        </div>
      </div>
     
    </div> 
  
<div class="Global">
     <TopTen :scores="scores" :heading="'Global'" showDifficulty="true" :highlight="selectedName"/>
     </div>
 <div class="panelBase">
  <router-link to="/leaderboard" tag="button" class="pillBtn">Leaderboard: Top 10</router-link> 
 </div>
  </div>
  <div class="anthemIcon" style="transform:scale(1.5);top:10px;"></div>
  </div>
</template>

<script>
// @ is an alias to /src
import TopTen from '@/components/TopTen.vue'
import SearchBox from '@/components/SearchBoxM.vue'

export default {
  name: 'Home',
  components: {
    TopTen,
    SearchBox
  },
  data() {
      return {
         selectedName:null
      }
  },
  mounted(){
   
  },
  computed:{
    scores(){
      let scores=this.$store.getters.getScores
      if (scores){
        return scores.sort( highScore )
      }
      return []
    },
     names(){
      return this.$store.getters.getNames || ["xxx"] 
    },
  },
  methods:{
    showScore(val){
      this.selectedName=val
      console.log("ShowScore",val)
    },
    scoreType(sType){
      let scores=[]
      for(var s in this.scores){
        if(this.scores[s].Difficulty==sType){
          scores.push(this.scores[s])
        }
      }
      return scores.sort( highScore );
    }
  }
}

function highScore( a, b ) {
  if ( a.score < b.score ){
    return 1;
  }
  if ( a.score> b.score ){
    return -1;
  }
  return 0;
}
</script>
<style lang="scss" >
  .anthemBG{
    padding:7em 2em;
  }
  .Global{

  .rowSelected{
    background-color:#eef7ee;
     border-top:none!important;
     margin-top:5px!important; 
  }
  }
  @media only screen and (max-width: 620px) {
    .panel{
      font-size:15px;
      border-radius:0em;
    }
    .panelTop{
      padding:2.5em 2em;
    }
    .anthemBG{
      padding:7em 0em;
    }
    .title{
      font-size:2.1em;
    }
  }
  @media only screen and (max-width: 520px) {
  .panel{
      font-size:14px;
    }
    .title{
      font-size:2.31em;
    }
  }
</style>
